import {
    APPLY_COUNTERS_FROM_POPUP_METRIKA_COUNTER_EDITOR,
    CANCEL_COUNTERS_FROM_POPUP_METRIKA_COUNTER_EDITOR,
    CHANGE_MARK_LINKS_METRIKA_COUNTER_EDITOR,
    CLOSE_METRIKA_COUNTER_EDITOR,
    MetrikaCounterEditorAction,
    OPEN_METRIKA_COUNTER_EDITOR,
    OpenMetrikaCounterEditorAction,
    SELECT_COUNTER_METRIKA_COUNTER_EDITOR,
    SelectCounterMetrikaCounterEditorAction,
    SET_METRIKA_UNAVAILABLE_FLAG_FOR_METRIKA_COUNTER_EDITOR,
    SHOW_METRIKA_COUNTER_EDITOR_ERRORS,
    UPDATE_COUNTERS_METRIKA_COUNTER_EDITOR
} from '../actions/metrikaCounterEditor';
import {
    metrikaCounterEditorInitialData,
    metrikaCounterEditorInitialValue
} from '../service/MetrikaCounterEditor/MetrikaCounterEditor';
import { MetrikaCounterEditorState } from '../typings/metrikaCounterEditor';
import { State } from '../typings/state';

export const metrikaCounterEditorInitialState = {
    editors: {}
};

const openMetrikaCounterEditorReducer = (
    state: MetrikaCounterEditorState,
    action: OpenMetrikaCounterEditorAction
): MetrikaCounterEditorState => {
    const editorId = action.editorId;
    const editorState =
        state.editors[editorId] || metrikaCounterEditorInitialData;
    const value = action.savedValue || metrikaCounterEditorInitialValue;

    return {
        ...state,
        editors: {
            [editorId]: {
                ...editorState,
                selectedCounters: value.counters,
                appliedCounters: value.counters,
                markMetrikaLinks: value.markMetrikaLinks,
                isOpen: true
            }
        }
    };
};

const selectCounterMetrikaCounterEditorReducer = (
    state: MetrikaCounterEditorState,
    action: SelectCounterMetrikaCounterEditorAction
): MetrikaCounterEditorState => {
    const editorId = action.editorId;
    const editorState =
        state.editors[editorId] || metrikaCounterEditorInitialData;

    let selectedCounters = editorState.selectedCounters || [];
    if (selectedCounters.includes(action.counter)) {
        selectedCounters = selectedCounters.filter(
            item => item !== action.counter
        );
    } else {
        selectedCounters = [...selectedCounters, action.counter];
    }

    return {
        ...state,
        editors: {
            [action.editorId]: {
                ...editorState,
                selectedCounters
            }
        }
    };
};

export function metrikaCounterEditor(
    state: MetrikaCounterEditorState = metrikaCounterEditorInitialState,
    action: MetrikaCounterEditorAction,
    fullState: State
): MetrikaCounterEditorState {
    switch (action.type) {
        case OPEN_METRIKA_COUNTER_EDITOR:
            return openMetrikaCounterEditorReducer(state, action);

        case CLOSE_METRIKA_COUNTER_EDITOR:
            const editorId = action.editorId;
            const editorState =
                state.editors[editorId] || metrikaCounterEditorInitialData;

            return {
                ...state,
                editors: {
                    [editorId]: {
                        ...editorState,
                        isOpen: false
                    }
                }
            };

        case SELECT_COUNTER_METRIKA_COUNTER_EDITOR:
            return selectCounterMetrikaCounterEditorReducer(state, action);

        case CHANGE_MARK_LINKS_METRIKA_COUNTER_EDITOR:
            return {
                ...state,
                editors: {
                    [action.editorId]: {
                        ...state.editors[action.editorId],
                        markMetrikaLinks: !state.editors[action.editorId]
                            .markMetrikaLinks
                    }
                }
            };

        case UPDATE_COUNTERS_METRIKA_COUNTER_EDITOR:
            return {
                ...state,
                counters: action.counters,
                isMetrikaAvailable: true
            };

        case SET_METRIKA_UNAVAILABLE_FLAG_FOR_METRIKA_COUNTER_EDITOR: {
            return {
                ...state,
                isMetrikaAvailable: action.isAvailable,
                counters: []
            };
        }

        case APPLY_COUNTERS_FROM_POPUP_METRIKA_COUNTER_EDITOR: {
            const selectedCounters =
                state.editors[action.editorId].selectedCounters || [];

            return {
                ...state,
                editors: {
                    [action.editorId]: {
                        ...state.editors[action.editorId],
                        appliedCounters: [...selectedCounters],
                        errors: []
                    }
                }
            };
        }

        case CANCEL_COUNTERS_FROM_POPUP_METRIKA_COUNTER_EDITOR: {
            return {
                ...state,
                editors: {
                    [action.editorId]: {
                        ...state.editors[action.editorId],
                        selectedCounters: [
                            ...state.editors[action.editorId].appliedCounters
                        ]
                    }
                }
            };
        }

        case SHOW_METRIKA_COUNTER_EDITOR_ERRORS: {
            return {
                ...state,
                editors: {
                    [action.editorId]: {
                        ...state.editors[action.editorId],
                        errors: action.errors
                    }
                }
            };
        }

        default:
            return state;
    }
}
